import React from 'react';
import * as S from './styles';
import { HeadingProps } from './types';

function ForwardedHeading<As extends React.ElementType>(
  {
    align,
    as,
    children,
    letterSpacing,
    level,
    lineHeight,
    size,
    textTransform,
    variant = 'desktop',
    weight,
    ...props
  }: HeadingProps<As>,
  ref: React.ForwardedRef<React.ElementRef<As>>,
): React.ReactElement | null {
  const Element: React.ElementType = as ?? `h${level}`;

  return (
    <S.Root
      $align={align}
      $letterSpacing={letterSpacing}
      $textTransform={textTransform}
      $level={level}
      $size={size}
      $lineHeight={lineHeight}
      $variant={variant}
      $weight={weight}
      as={Element}
      ref={ref}
      {...props}
    >
      {children}
    </S.Root>
  );
}

export const Heading = React.forwardRef(ForwardedHeading) as <
  As extends React.ElementType,
>(
  props: HeadingProps<As> & { ref?: React.Ref<React.ElementRef<As>> },
) => React.ReactElement | null;

export default Heading;
